// Theme helpers for tenant websites: CSS variables + Google Fonts loader. Pure functions, no React.
export const FONT_IMPORTS = {
  'Barlow Condensed': 'Barlow+Condensed:wght@600;700;800;900', 'Bebas Neue': 'Bebas+Neue', Oswald: 'Oswald:wght@500;600;700',
  Montserrat: 'Montserrat:wght@400;500;600;700;800', 'Playfair Display': 'Playfair+Display:wght@500;600;700;800', 'DM Sans': 'DM+Sans:wght@400;500;700',
  'Space Grotesk': 'Space+Grotesk:wght@400;500;600;700', Lora: 'Lora:wght@400;500;600;700', Inter: 'Inter:wght@400;500;600;700;800',
};

export const loadFonts = (...names) => {
  const fams = [...new Set(names.filter(Boolean))].map((n) => FONT_IMPORTS[n]).filter(Boolean);
  if (!fams.length) return;
  const key = fams.join('|');
  if (document.querySelector(`link[data-site-fonts="${key}"]`)) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?${fams.map((f) => `family=${f}`).join('&')}&display=swap`;
  link.setAttribute('data-site-fonts', key);
  document.head.appendChild(link);
};

const hexToRgb = (hex) => {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
  return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : [0, 0, 0];
};
const luminance = (hex) => { const [r, g, b] = hexToRgb(hex).map((c) => { const s = c / 255; return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4; }); return 0.2126 * r + 0.7152 * g + 0.0722 * b; };
export const onColor = (hex) => (luminance(hex) > 0.45 ? '#111111' : '#FFFFFF');

// Derived palette used by every section. `t` = site.theme.
export const palette = (t) => {
  const dark = t.mode === 'dark';
  const bg = t.secondary || (dark ? '#0A0A0A' : '#FFFFFF');
  return {
    dark, bg, bgAlt: dark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.035)', surface: dark ? '#141414' : '#FFFFFF',
    text: dark ? '#FFFFFF' : (t.accent || '#0F172A'), muted: dark ? 'rgba(255,255,255,0.62)' : 'rgba(15,23,42,0.64)', faint: dark ? 'rgba(255,255,255,0.4)' : 'rgba(15,23,42,0.45)',
    line: dark ? 'rgba(255,255,255,0.12)' : 'rgba(15,23,42,0.12)', primary: t.primary, onPrimary: onColor(t.primary),
    radius: t.button_style === 'pill' ? 999 : t.button_style === 'rounded' ? 10 : 2,
    heading: `'${t.heading_font}', sans-serif`, body: `'${t.body_font}', sans-serif`,
    headingTransform: ['Barlow Condensed', 'Bebas Neue', 'Oswald'].includes(t.heading_font) ? 'uppercase' : 'none',
  };
};

export const splitLines = (s) => String(s || '').split('\n');
